import classes from '@/components/Shares/Button.module.css';
import { useBunker } from '@/providers/BunkerProvider';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Button, Flex, Group, ScrollArea, Stack, type StackProps, Text, rem } from '@mantine/core';
import { BunkerInventoryItem } from './BunkerInventoryItem';
import { bunkerInventoryData } from './data';
export const BunkerInventorySection: React.FC<StackProps> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  const {
    selectedPart,
    setActive
  } = useBunker();
  const {
    setOpenModal
  } = useModalAction();
  const item = bunkerInventoryData.filter(item => item.isLocked === false);
  return <Stack {...props}>
      <Group justify="space-between">
        <Box>
          <Text fz="xs" fw={700} c="var(--text-prime)">
            {i18n._('INVENTORY')}
          </Text>

          <Text fz={{
          base: 21,
          sm: 24,
          lg: 32
        }} lh={{
          base: rem(21),
          sm: rem(24),
          lg: rem(32)
        }} className={gunterzBold.className} c="var(--text-white)">
            {selectedPart.part}
            <Text fz={{
            base: 14,
            sm: 20,
            lg: 22
          }} lh={{
            base: rem(14),
            sm: rem(20),
            lg: rem(22)
          }} fw={700} component="sup" c="var(--text-prime)">
              {`(${item.length})`}
            </Text>
          </Text>
        </Box>

        <Button w={96} h={46} fz={13} className={classes.root} visibleFrom="lg" onClick={() => {
        setOpenModal(MODAL.BUNKER_SUCCESS);
      }}>
          {i18n._('Save')}
        </Button>
      </Group>

      <ScrollArea h={{
      base: 160,
      lg: 620
    }} w="100%" scrollbars="xy" scrollbarSize={5}>
        <Flex gap={16} py={20} wrap={{
        base: 'nowrap',
        lg: 'wrap'
      }}>
          {bunkerInventoryData.map(item => <BunkerInventoryItem key={item.id} handleClick={() => {
          !item.isLocked && setActive(item);
        }} {...item} />)}
        </Flex>
      </ScrollArea>

      <Button w={{
      base: 125,
      sm: 142
    }} h={46} fz={13} ml="auto" mt={{
      base: 4,
      sm: 16
    }} className={classes.root} hiddenFrom="lg" onClick={() => {
      // setSuccess(true)
      setOpenModal(MODAL.BUNKER_SUCCESS);
    }}>
        {i18n._('Save')}
      </Button>
    </Stack>;
};